import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as queryString from 'query-string';

import PersonalInformation from './PersonalInformation';
import TellUsAboutYourself from './TellUsAboutYourself';
import SportType from './SportType';
import YourRating from './YourRating';
import ColorBallPlayer from './ColorBallPlayer';
import ColorBallType from './ColorBallType';
import TennisSelfRating from './TennisSelfRating';
import ClaimProfile from './ClaimProfile';
import PickleballSelfRating from './PickleballSelfRating';
import TennisAustralia from './TennisAustralia';
import SplashV3 from '../../components/Splash/splashV3';
import withActivateUtr from '../../components/hocs/withActivateUtr';
import { isUtrActivationInProgress, getRedirectUrl, shouldNavigateToRedirectUrl, shouldCallConnectPlayerThirdPartyId } from '../../utils/activateUtr';
import { connectThirdPartyId } from '../../actions/activate-utr-actions';
import { getOnboardingStatusV2 } from '../../actions/onboarding-actions';

import styles from './nuoV2.scss';
import NCSA from './NCSA';
import UtrRating from './YourRating/UtrRating';
import ColorBallRating from './YourRating/ColorBallRating';
import PickleballRating from './YourRating/PickleBallRating';
import { NuoSteps, ratingDisplaySteps } from './YourRating/constants';

const NuoV2PageWrapper = (props) => {
    const { activateUtr } = props;
    const nuo = useSelector(({ onboarding }) => onboarding.nuo);
    const queryParams = props.location.search;
    const parsed = queryString.parse(queryParams);

    const { loading, data, showRating, isFromStep } = nuo;
    const auth = useSelector(({ auth }) => auth);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!auth.user.onboardingCompleted) {
            dispatch(getOnboardingStatusV2());
        } else if (shouldNavigateToRedirectUrl(activateUtr)) {
            window.location.href = getRedirectUrl(activateUtr);
        } else if (parsed.return) {
            props.history.push(parsed.return);
        } else {
            props.history.push({
                pathname: '/home',
            });
        }
    }, []);

    useEffect(() => {
        if (auth.user.onboardingCompleted) {
            if (shouldNavigateToRedirectUrl(activateUtr)) {
                window.location.href = getRedirectUrl(activateUtr);
            } else {
                const parsed = queryString.parse(queryParams);
                if (!showRating) {
                    if (parsed.return) {
                        props.history.push(parsed.return);
                    } else {
                        props.history.push({
                            pathname: '/home',
                        });
                    }
                }
            }
        }
    }, [auth.user.onboardingCompleted, showRating, activateUtr]);

    useEffect(() => {
        const isActivationInProgress = isUtrActivationInProgress(activateUtr);
        if (isActivationInProgress && !loading && shouldCallConnectPlayerThirdPartyId(activateUtr) && !!auth.user.claimedPlayer) {
            dispatch(connectThirdPartyId({
                type: activateUtr.activationType,
                token: activateUtr.activationToken,
            }, true));
        }
    }, [activateUtr, auth.user, loading]);

    const pageProps = {
        nuo,
        disableRangeSurveySkip: false,
        isFromOnboarding: true,
        location: props.location,
        initiatePlayerWithSportTypeId: parsed?.initiatingSportTypeId,
        marketingEmailsOptIn: auth?.australiaSettings?.marketingEmailsOptIn,
    };

    const pages = {
        'additional-info': <PersonalInformation {...pageProps} />,
        'member-type': <TellUsAboutYourself {...pageProps} />,
        'sport-type': <SportType {...pageProps} auth={auth} />,
        'utr-survey': <TennisSelfRating {...pageProps} />,
        'colorball-player': <ColorBallPlayer {...pageProps} />,
        'cbr-survey': <ColorBallType {...pageProps} />,
        'create-player': <ClaimProfile {...pageProps} />,
        'pkbr-survey': <PickleballSelfRating {...pageProps} />,
        'ncsa-registration': <NCSA {...pageProps} />,
        'utr-rating': <UtrRating {...pageProps} />,
        'cbr-rating': <ColorBallRating {...pageProps} />,
        'pkbr-rating': <PickleballRating {...pageProps} />,
        rating: <YourRating {...pageProps} />,
        'australia-onboarding': <TennisAustralia {...pageProps} activateUtr={activateUtr} />,
    };

    const getCurrentPage = () => {
        if (showRating && !isUtrActivationInProgress(activateUtr)) {
            const step = ratingDisplaySteps.find((rdStep) => rdStep.isFromStep === isFromStep);
            const type = step?.type || NuoSteps.Rating;
            return pages[type];
        }
        return data?.nextStep?.name ? pages[data.nextStep.name] : null;
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [data?.nextStep?.name]);

    if (loading) {
        return (
            <SplashV3 />
        );
    }

    return (
        <div className={styles.page}>
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-6 offset-md-3">
                        {getCurrentPage()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withRouter(withActivateUtr(NuoV2PageWrapper));
